// extracted by mini-css-extract-plugin
export default {"tableDataCell":"TableDataCell_tableDataCell__7vHUG"};